import React, { useCallback } from "react";
import { RadioButton, RadioButtonGroup } from "@folio/stripes/components";
import { useIntl } from "react-intl";
var HANDLER_ORDER = ["PERIODICALS", "MONOGRAPHS"];
export var AgendaHandlerChoice = function (_a) {
    var name = _a.name, side = _a.side, value = _a.value, onChange = _a.onChange;
    var formatMessage = useIntl().formatMessage;
    var handleChange = useCallback(function (agenda) { return function () { return onChange(agenda); }; }, [onChange]);
    return (React.createElement(RadioButtonGroup, { label: formatMessage({
            id: "ui-br-legaldeposits.agenda.issue.handler.label",
        }) }, HANDLER_ORDER.map(function (agenda) { return (React.createElement(RadioButton, { key: agenda, "data-test-id": "agenda-handler-".concat(agenda), name: name, label: formatMessage({
            id: "ui-br-legaldeposits.agenda.issue.handler.".concat(side, ".").concat(agenda),
        }), checked: value === agenda, onChange: handleChange(agenda) })); })));
};
